import { useLayoutEffect, useRef } from 'react';

/**
 * Auto-grows a textarea to fit its content whenever `value` changes. Height is
 * content-driven; bound it via the element's own `minHeight` (initial
 * multi-line size) and `maxHeight` (viewport-relative cap — the browser clamps
 * the assigned height and the textarea scrolls internally beyond it). The
 * element style should use `boxSizing: 'border-box'` so the measured
 * scrollHeight maps 1:1 onto the assigned height.
 */
export function useAutoGrowTextarea(value: string) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    // Collapse first so shrinking content can reduce the height, then fit.
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + el.offsetHeight - el.clientHeight}px`;
  }, [value]);

  return ref;
}
